import httpService from "./httpService";

const apiEndpoint = process.env.REACT_APP_BACKEND_API_PATH

function getTopics() {
    return httpService.get(apiEndpoint + '/categories')
}

function getPosts(categoryId) {
    return httpService.get(apiEndpoint + '/posts', {
        params: {
            categoryId
        }
    })
}

function newPost(title, body, categoryId) {
    return httpService.post(apiEndpoint + '/posts/new', new URLSearchParams({
        title,
        body,
        categoryId
    }), {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    })
}

function getUserPosts(username) {
    return httpService.get(apiEndpoint + `/posts/${username}`)
}

function getPost(id) {
    return httpService.get(apiEndpoint + `/post/${id}`)
}

function getPostReplies(id) {
    return httpService.get(apiEndpoint + `/post/${id}/replies`)
}

function newReply(id, body) {
    return httpService.post(apiEndpoint + `/post/${id}/replies/new`, new URLSearchParams({
        id,
        body
    }), {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    })
}

function search(query, target = "posts") {
    return httpService.get(apiEndpoint + "/search", {
        params: {
            query,
            target,
        },
    });
}

function bookmark(id) {
    return httpService.post(apiEndpoint + `/post/${id}/bookmark`)
}

function getBookmarked() {
    return httpService.get(apiEndpoint + '/posts/me/bookmarks')
}

function deletePost(id) {
    return httpService.post(apiEndpoint + `/post/${id}/delete`)
}

function deleteReply(id) {
    return httpService.post(apiEndpoint + `/reply/${id}/delete`)
}

function like(id) {
    return httpService.post(apiEndpoint + `/post/${id}/like`)
}

function getTrending(code, categoryId) {
    return httpService.get(apiEndpoint + `/posts/trending`, {
        params: {
            code,
            categoryId,
        },
    })
}

function getStatistics(code){
    return httpService.get(apiEndpoint + `/admin/statistics/posts`, {
        params: {
            code,
        },
    })
}

export default {
    getTopics,
    getPosts,
    newPost,
    getUserPosts,
    getPost,
    getPostReplies,
    newReply,
    search,
    bookmark,
    getBookmarked,
    deletePost,
    deleteReply,
    like,
    getTrending,
    getStatistics
}